
/**
 * 결제 주기
 */
export type GetPlanChangeOptions200UpgradeOptionsItemBillingCycle = typeof GetPlanChangeOptions200UpgradeOptionsItemBillingCycle[keyof typeof GetPlanChangeOptions200UpgradeOptionsItemBillingCycle];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetPlanChangeOptions200UpgradeOptionsItemBillingCycle = {
  MONTHLY: 'MONTHLY',
  YEARLY: 'YEARLY',
  ONE_TIME: 'ONE_TIME',
} as const;
